import { Button } from "components/Button";
import { Header } from "components/Header";
import { InputFormField } from "components/InputFormField";
import { Loading } from "components/Loading";
import { PlaceHolderNotExists } from "components/PlaceholderNotExists";
import { TableModifiedCards } from "components/TableModified/TableModifiedCards";
import { TableModifiedFilters } from "components/TableModified/TableModifiedFilters";
import { TableModifiedPagination } from "components/TableModified/TableModifiedPagination";
import { TableModifiedTable } from "components/TableModified/TableModifiedTable";
import React from "react";
import { useHistory } from "react-router-dom";
import { Container, TableSearchEvents } from "./styles";
import { useEventsTable } from "./useEventsTable";

const tableHead = ["Nome", "Organizador", "Endereço", "Capacidade", "Publicado", "Descrição da data"," "];

export const EventsTable: React.FC = () => {
  const { push } = useHistory();
  const {
    loading,
    error,
    properties,
    eventRows,
    eventsCount,
    searchText,
    tableFilters,
    searchTextFormRef,
    pageNumber,
    eventsPerPage,
    handleSearchTextFormSubmit,
    handleFilterChange,
    handleFilterRemove,
    handleSearchTextRemove,
    handlePageSelected,
    handleRowsPerPageChange,
  } = useEventsTable();

  const handleCreateEvent = () => {
    push('/events/create');
  };

  return (
    <Container>
      <Header>
        <div style={{ display: 'flex', gap: '1rem', alignItems: 'end', justifyContent: 'space-between' }}>
          <TableSearchEvents
            className="table-search-events"
            onSubmit={handleSearchTextFormSubmit}
            ref={searchTextFormRef}
            style={{ flex: 1 }}
          >
            <InputFormField 
              label="Buscar Eventos" 
              autoFocus={true} 
              name="searchText" 
              marginBotton={"0"} 
              backGround={"white"} 
              defaultValue={searchText}
              block={true} 
            />
            <Button 
              label="Buscar" 
              typeBtn="blue"
              type="submit"
              block={false} 
            />
          </TableSearchEvents>
          
          <Button 
            label="Criar Evento" 
            typeBtn="blue"
            type="button"
            onClick={handleCreateEvent}
            block={false} 
          />
        </div>
      </Header>
      <TableModifiedFilters
        filters={tableFilters}
        searchTextFilter={searchText}
        onFilterChange={handleFilterChange}
        onFilterRemove={handleFilterRemove}
        onSearchTextRemove={handleSearchTextRemove}
      />
      {
        loading
        ? <Loading/>
        : error
          ? <PlaceHolderNotExists title="Erro ao se comunicar com o servidor"/>
          : <>
              <TableModifiedCards
                properties={properties}
              />
              <TableModifiedTable
                headerColumns={tableHead}
                rows={eventRows}
              />
            </>
      }
      {
        eventsCount > 0
        ? <TableModifiedPagination
            totalItemsCount={eventsCount}
            pageNumber={pageNumber}
            rowsPerPage={eventsPerPage}
            onPageSelected={handlePageSelected}
            onRowsPerPageChange={handleRowsPerPageChange}
          />
        : null
      }
    </Container>
  );
} 